<div>
  <app-login-header class="w-100"></app-login-header>
  <div class="px-3 py-4">
    <router-outlet></router-outlet>
  </div>
</div>
